import React, { memo } from 'react';

import { StyledBadge } from './Badge.styles';

import { BadgeProps } from './Badge.types';

/**
 * Small count and labeling component
 */
//TODO Remove Duplicate "className" prop (duplicate of "customClassnames")
const Badge = ({
  borderRadius = '12px',
  color = '#fff',
  backgroundColor = '#000',
  text,
  padding = '0 6px',
  className = '',
  componentClassname = 'back-to-top',
  customClassnames = '',
  customStyle = '',
}: BadgeProps) => {
  return (
    <StyledBadge
      className={`${componentClassname} ${customClassnames} ${className}`}
      color={color}
      backgroundColor={backgroundColor}
      borderRadius={borderRadius}
      padding={padding}
      customStyle={customStyle}
    >
      {text}
    </StyledBadge>
  );
};
Badge.displayName = 'Badge';

export default memo(Badge);
